$( document ).ready(function() {

  // IMAGES
  initLQIP()
  
  // HEIGHT VIEWPORT
  const windowHeight = document.documentElement.clientHeight;
  document.documentElement.style.setProperty('--viewport-height', `${windowHeight}px`);

  // MENU
  // $('.has-childs').click(function (e) { 
  //   e.preventDefault();
  //   var el = $(this);
  //   el.parent().toggleClass("show");    
  // });

  // NEWSLETTER
  setTimeout(function() { 
    $('html').addClass('show-newsletter');
  }, 20000);
  $('#newsletter-popup-overlay, #newsletter-popup-close').click(function () {
    $('html').removeClass('show-newsletter');
  });

  // SEARCH
  $('.search-trigger').click(function () {  
    $('html').addClass("show-search");
    $('.search-input').focus();
  });
  $('.search-close').click(function () {  
    $('html').removeClass("show-search");
  });

  // OUR STORY - ISSUES
  $('.issue-trigger').click(function () {  
    var index = $(this).index(); index = index + 1;
    console.log(index);
    $('.issue-trigger, .issue-product-container').removeClass('active');
    $('.issue-trigger:nth-child(' + index + '), .issue-product-container:nth-child(' + index + ')').addClass('active');
  });

  // NOTIFY ME CLOSE
  $('#notify-me-close').click(function () {  
    $('.restock-alerts-modal-close-btn').click();
  });

  // ABOUT FEATURES
  $('.about-features-next').click(function () {  
    var container = $(this).closest('.about-features');
    var el = container.find('.about-feature.active');
    var next = el.next('.about-feature');
    if (next.length) {
      el.removeClass('active');
      next.addClass('active');
    } else {
      el.removeClass('active');
      container.find('.about-feature').not('.in-about').first().addClass('active');
    }
    var activeIndex = container.find('.about-feature.active').index() + 1;
    container.find('.current-feature').text(activeIndex);
  });

  // Initialize Swiper for each lightbox-swiper on the page
  $('.lightbox-swiper').each(function(index) {
    var swiperElement = this;
    var $swiperElement = $(this);
    
    const carouselSwiper = new Swiper(swiperElement, {
      loop: true,
      speed: 500,
      spaceBetween: 0,
      grabCursor: false,
      navigation: {
        nextEl: $swiperElement.find('.next-button')[0],
      },
      breakpoints: {
        820: {
          speed: 1
        },
      },
    });

    carouselSwiper.on('slideChangeTransitionEnd', function () {
      var activeIndex = $swiperElement.find('.swiper-slide-active').data('swiper-slide-index') + 1;
      $swiperElement.find('.current-index').text(activeIndex);
    });
  });

  // LIGHTBOX 
  $('.carousel-content, .article-carousel-content .swiper-wrapper').click(function () {
    var el = $(this).closest('.lightbox-swiper'),
        ww = $(window).width();
    if (ww <= 820) return;
    
    // Get the Swiper instance from the original carousel
    var originalSwiper = el[0].swiper;
    var activeSlideIndex = originalSwiper ? originalSwiper.realIndex : 0;
    console.log('Active slide index:', activeSlideIndex);
    
    // Remove existing lightbox to ensure fresh content for each carousel
    $('#lightbox-container').remove();
    
    $('body').append(`
      <div id="lightbox-container">
        <div id="lightbox-overlay-click"></div>
        ${el.prop('outerHTML')}
      </div>
    `);
    
    $("#lightbox-container .carousel-bar, #lightbox-container .article-carousel-bar").prepend('<div class="carousel-close uppercase">Close</div>');

    // Reorder slides by data-swiper-slide-index before initializing Swiper
    var $wrapper = $('#lightbox-container .swiper-wrapper');
    var $slides = $wrapper.find('.swiper-slide').get();
    
    $slides.sort(function(a, b) {
      var aIndex = parseInt($(a).data('swiper-slide-index')) || 0;
      var bIndex = parseInt($(b).data('swiper-slide-index')) || 0;
      return aIndex - bIndex;
    });
    
    $wrapper.empty().append($slides);

    const carouselSwiper = new Swiper('#lightbox-container .lightbox-swiper', {
      loop: true,
      speed: 500,
      spaceBetween: 0,
      grabCursor: false,
      // initialSlide: activeSlideIndex,
      navigation: {
        nextEl: '#lightbox-container .media, #lightbox-container .next-button',
      },
      breakpoints: {
        820: {
          speed: 1
        },
      },
    });
    $('#lightbox-container .swiper-wrapper').css('transform', 'none');
    $('#lightbox-container .current-index').text(activeSlideIndex + 1);

    carouselSwiper.slideToLoop(activeSlideIndex, 0);

    carouselSwiper.on('slideChangeTransitionEnd', function () {
      var container = $('#lightbox-container');
      var activeIndex = container.find('.swiper-slide-active').data('swiper-slide-index') + 1;
      container.find('.current-index').text(activeIndex);
    });
    
    $("html").addClass('show-lightbox');
  });
  $(document).off("click",".carousel-close").on("click",".carousel-close",function() {
    $("html").removeClass('show-lightbox');
  });
  $(document).off("click","#lightbox-overlay-click").on("click","#lightbox-overlay-click",function() {
    $("html").removeClass('show-lightbox');
  });
  // $(document).off("click","#lightbox-container .media").on("click","#lightbox-container .media",function() {
  //   $(".carousel-next, .article-carousel-next").click();
  // });

  // PRODUCT CONTRIBUTORS
  var allContributors = $('.product-contributor'),
      allGroups = $('.product-contributor-group'),
      ww = $(window).width();
  function updateContributorCounts() {
    if (ww <= 820) {
      $('.contributors-total').text(allContributors.length);
    } else {
      $('.contributors-total').text(allGroups.length);
    }
  }
  updateContributorCounts();
  $(window).resize(function() {
    ww = $(window).width();
    updateContributorCounts();
  });

  $('.contributors-next').click(function () {  
    // DESKTOP
    var el = $('.product-contributor-group.active');
    var next = el.next('.product-contributor-group');
    if (next.length) {
      el.removeClass('active');
      next.addClass('active');
    } else {
      el.removeClass('active');
      $('.product-contributor-group').first().addClass('active');
    }
    
    // MOBILE
    var currentActive = allContributors.filter('.active');
    var currentIndex = allContributors.index(currentActive);
    var nextIndex = (currentIndex + 1) % allContributors.length;
    
    allContributors.removeClass('active');
    allContributors.eq(nextIndex).addClass('active');

    // COUNTER
    if (ww > 820) {
      var activeIndex = $('.product-contributor-group.active').index() + 1;
      console.log(activeIndex);
      $('.contributors-current').text(activeIndex);
    } else {
      var activeIndexMobile = nextIndex + 1;
      $('.contributors-current').text(activeIndexMobile);
    }
  });

  // PRODUCT CAROUSEL
  $(document).off("click",".module-carousel .carousel-next").on("click",".module-carousel .carousel-next",function() {
    var container = $(this).closest('.carousel-container');
    var el = container.find('.carousel-image-container.active');
    var next = el.next('.carousel-image-container');
    var firstImage = container.find('.carousel-image-container').first();
    if (next.length) {
      el.removeClass('active');
      next.addClass('active');
    } else {
      el.removeClass('active');
      firstImage.addClass('active');
    }
    var activeIndex = container.find('.carousel-image-container.active').index() + 1;
    container.find('.carousel-current').text(activeIndex);
  });

  // ARTICLE CAROUSEL
  // $(document).off("click","#article-container .article-carousel-next").on("click","#article-container .article-carousel-next",function() {
  //   var container = $(this).closest('.article-carousel-container');
  //   var el = container.find('.article-carousel-image.active');
  //   var next = el.next('.article-carousel-image');
  //   var firstImage = container.find('.article-carousel-image').first();
  //   if (next.length) {
  //     el.removeClass('active');
  //     next.addClass('active');
  //   } else {
  //     el.removeClass('active');
  //     firstImage.addClass('active');
  //   }
  //   var activeIndex = container.find('.article-carousel-image.active').index() + 1;
  //   container.find('.article-carousel-counter-current').text(activeIndex);
  // });

  // CONTRIBUTORS 
  $('.contributor').hover(function () {
    var el = $(this),
        handle = el.data('handle'),
        ww = $(window).width();
    if (ww <= 820) return;
    $('.contributor, .contributor-content').removeClass('active');
    el.addClass('active');
    $('.contributor-content[data-handle="' + handle + '"]').addClass('active');
  });
  $('.contributor').click(function () {
    var el = $(this),
        handle = el.data('handle'),
        ww = $(window).width();
    if (ww > 820) return;
    $('.contributor, .contributor-content').removeClass('active');
    el.addClass('active');
    $('.contributor-content[data-handle="' + handle + '"]').addClass('active');
    console.log($("#contributors-content-container").offset().top - 48, $('body').scrollTop());
    $('html, body').animate({ scrollTop: $("#contributors-content-container").offset().top - 48 + $('body').scrollTop() }, 1000);
  });

  // CONTENTS 
  $('.contents-title').hover(function () {
    var el = $(this),
        index = el.index(); index = index + 1;
    $('.contents-title, .contents-text').removeClass('active');
    el.addClass('active');
    $('.contents-text:nth-child(' + index + ')').addClass('active');
  });
  
  function setHeaderHeightVar() {
    var header = document.getElementById('header');
    if (header) {
      var height = header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', height + 'px');
    }
  }
  setHeaderHeightVar();
  window.addEventListener('resize', setHeaderHeightVar);

  // MOBILE NAVIGATION
  $('#mobile-menu-trigger').click(function () {
    $('body').toggleClass('show-mobile-menu');
    $('html').removeClass('show-search');
  });

  $('a.has-childs').click(function (e) {
    if (ww <= 820) {
      e.preventDefault();
      var parent = $(this).parent('.has-childs-container');
      $('.has-childs-container').not(parent).removeClass('active').find('.sub-menu-container').slideUp(200);
      if (parent.length) {
        parent.toggleClass('active');
        parent.find('.sub-menu-container').slideToggle(200);
      }
    }
  });

  $('#mobile-landing-text-trigger').click(function () {
    $('#mobile-landing-logos-trigger').removeClass('active');
    $(this).addClass('active');
    $('html').addClass('show-landing-text');
  });
  
  $('#mobile-landing-logos-trigger').click(function () {
    $('#mobile-landing-text-trigger').removeClass('active');
    $(this).addClass('active');
    $('html').removeClass('show-landing-text');
  });

  // ZOOM MOBILE
  $(document).off("click",".carousel-fullscreen").on("click",".carousel-fullscreen",function() {
    var activeImage = $(this).parent().find('.swiper-slide-active.zoomable-mobile');
    activeImage.click();
  });
  $(document).off("click",".zoomable-mobile").on("click",".zoomable-mobile",function() {
    var ww = $(window).width();
    if (ww > 820) return;
    console.log('Zoom');
    
    var imageEl = $(this).find('img');
    if (!imageEl.length) return;
    
    var imageSrc = imageEl.attr('src');
    
    $('#zoom-container').remove();
    
    $('body').append(`
      <div id="zoom-container">
        <div id="zoom-close" class="uppercase">Close</div>
        <div id="zoom-content">
          <img src="${imageSrc}" alt="Zoomed image" id="zoom-image">
        </div>
      </div>
    `);
    
    // Centrar la imagen cuando se cargue
    $('#zoom-image').on('load', function() {
      var zoomContent = $('#zoom-content');
      var img = $(this);
      
      var containerWidth = zoomContent.width();
      var containerHeight = zoomContent.height();
      var imageWidth = img.width();
      var imageHeight = img.height();
      
      // Calcular el scroll necesario para centrar
      var scrollLeft = (imageWidth - containerWidth) / 2;
      var scrollTop = (imageHeight - containerHeight) / 2;
      
      // Aplicar scroll para centrar
      zoomContent.scrollLeft(scrollLeft);
      zoomContent.scrollTop(scrollTop);

      console.log(scrollLeft, scrollTop);
    });
    $('html').addClass('show-zoom');
  });

  $(document).off("click","#zoom-close, #zoom-overlay").on("click","#zoom-close, #zoom-overlay",function() {
    $('html').removeClass('show-zoom');
  });

  $('.mc-embedded-subscribe-form').submit(function(e) {
    e.preventDefault();
    var $form = $(this);
    var url = $form.attr('action').replace('/post?', '/post-json?') + '&c=?';
    $.ajax({
      type: 'GET',
      url: url,
      data: $form.serialize(),
      cache: false,
      dataType: 'jsonp',
      jsonp: 'c',
      contentType: 'application/json; charset=utf-8',
      success: function(data) {
        if (data.result === 'success') {
          $('.mce-success-response').html(data.msg).show();
          $('.mce-error-response').hide();
          $('.mce-responses').show();
          $form[0].reset();
        } else {
          $('.mce-error-response').html(data.msg).show();
          $('.mce-success-response').hide();
          $('.mce-responses').show();
        }
        setTimeout(function() {
          $('.mce-responses, .response').hide();
          $('html').removeClass('show-newsletter');
        }, 3000);
      }
    });
  });

});

function initLQIP() {
  const lqipImages = document.querySelectorAll('.media-lqip[data-lqip]');
  
  lqipImages.forEach(function(img) {
    // Set LQIP as background immediately for instant visual feedback
    const lqipSrc = img.getAttribute('data-lqip');
    if (lqipSrc) {
      const container = img.closest('.media-container') || img.parentElement;
      if (container) {
        // Preload LQIP for instant display
        const lqipImg = new Image();
        lqipImg.src = lqipSrc;
        
        // Set background immediately (LQIP is tiny, loads almost instantly)
        container.style.backgroundImage = 'url(' + lqipSrc + ')';
        container.style.backgroundSize = 'cover';
        container.style.backgroundPosition = 'center';
        container.style.backgroundRepeat = 'no-repeat';
      }
    }
    
    // When main image loads, remove blur and fade in
    if (img.complete && img.naturalWidth > 0) {
      // Image already loaded
      img.classList.add('loaded');
    } else {
      // Wait for image to load
      img.addEventListener('load', function() {
        img.classList.add('loaded');
      }, { once: true });
      
      // Also handle error case
      img.addEventListener('error', function() {
        // Remove blur even on error to show fallback
        img.classList.add('loaded');
      }, { once: true });
      
      // Fallback: remove blur after timeout even if load event doesn't fire
      setTimeout(function() {
        if (!img.classList.contains('loaded')) {
          img.classList.add('loaded');
        }
      }, 3000);
    }
  });
}